
<template>
    
        <mars-view v-if="lawInfo" class="law-regulation-item-container" @click.native="goDetail"><mars-rich-text :nodes="lawInfo.title" class="tip-content"></mars-rich-text><mars-view class="desc-box"><mars-view v-if="lawInfo.validStatus" class="effective"><mars-view class="desc">{{ lawInfo.validStatus }}</mars-view></mars-view><mars-view class="mechanism">{{ lawInfo.issueDepartment }}</mars-view></mars-view><mars-view class="content-box lineclamp2">
        {{ mainContent }}
        <mars-view class="content-more">
            ...全文
        </mars-view></mars-view><mars-view class="time-box"><mars-view v-if="lawInfo.formatIssueTime">发布：{{ lawInfo.formatIssueTime }}</mars-view><mars-view v-if="lawInfo.formatImplementTime" class="implement-time">实施：{{ lawInfo.formatImplementTime }}</mars-view></mars-view></mars-view>
    
</template>

<script>
import log from '../../../static/utils/ubcLog';
import { act } from '../../../static/utils/navigate';
import { formatTimeToDate } from '../../../pages/qalandpage/utils/util.js';
export default {
  props: {
    lawInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    mainContent() {
      let content = this.lawInfo && this.lawInfo.content || '';
      return content.replace(/[\s+<br><br\/>]/g, '');
    }
  },
  methods: {
    // 跳转-法律法规落地页
    goDetail() {
      let {
        qid
      } = this.lawInfo || {};
      if (!qid) {
        return;
      }
      act({
        target: `/pages/qaregulations/index?cid=${qid}&fr=law-search`,
        type: 'url'
      });
    }
  }
};
</script>

<style scoped>
.law-regulation-item-container {
  padding: 3.99vw 0 4.35vw;
  border-bottom: 0.16vw solid #edeef0;
}
.law-regulation-item-container .tip-content {
  font-family: PingFangSC-Medium;
  font-size: 4.35vw;
  color: #1f1f1f;
  line-height: 6.52vw;
  font-weight: 700;
}
.law-regulation-item-container .f-red {
  color: #eb3333;
}
.law-regulation-item-container .lineclamp2 {
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.law-regulation-item-container .desc-box {
  margin-top: 2.29vw;
  display: flex;
  align-items: center;
}
.law-regulation-item-container .desc-box .effective {
  flex-shrink: 0;
  height: 3.86vw;
  border: 0.24vw solid rgba(0, 85, 255, 0.4);
  border-radius: 0.97vw;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.law-regulation-item-container .desc-box .effective .desc {
  font-family: PingFangSC-Medium;
  font-weight: 700;
  margin-top: 0.24vw;
  padding: 0 0.97vw;
  font-size: 2.66vw;
  color: #05f;
  line-height: 2.66vw;
}
.law-regulation-item-container .desc-box .mechanism {
  width: 0;
  flex: 1;
  margin-left: 1.45vw;
  font-family: PingFangSC-Regular;
  font-size: 3.38vw;
  color: #848691;
  line-height: 3.38vw;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
.law-regulation-item-container .content-box {
  position: relative;
  margin-top: 0.85vw;
  font-family: PingFangSC-Regular;
  font-size: 3.38vw;
  color: #1e1f24;
  line-height: 5.56vw;
}
.law-regulation-item-container .content-box .content-more {
  position: absolute;
  bottom: 0;
  right: 0;
  font-family: PingFangSC-Regular;
  font-size: 3.38vw;
  color: #50525c;
  line-height: 5.56vw;
  background: #fff;
}
.law-regulation-item-container .content-box .content-more::before {
  content: "";
  width: 0.6rem;
  height: 100%;
  position: absolute;
  left: -0.6rem;
  top: 0;
  background: linear-gradient(to right, rgba(255, 255, 255, 0), #ffffff);
}
.law-regulation-item-container .time-box {
  display: flex;
  align-items: center;
  margin-top: 2.54vw;
  font-family: PingFangSC-Regular;
  font-size: 3.38vw;
  color: #b7b9c1;
  line-height: 3.38vw;
}
.law-regulation-item-container .time-box .implement-time {
  padding-left: 1.45vw;
}

</style>
